import { CMSLink } from '~/shared/components';
import styles from './meta-list.module.css';
import { clsx } from 'clsx';
import { Link } from '~/lib/data-contract';

type Props = {
    metaMenu: Link[];
    className?: string;
    onlyMobile?: boolean;
    onNavigationClick?: () => void;
};

export const MetaList = ({ metaMenu, className, onlyMobile, onNavigationClick }: Props) => {
    return (
        <ul className={clsx(styles.root, className, { [styles.onlyMobile]: onlyMobile })}>
            {metaMenu.map(({ text, id, url }) => (
                <li key={`${id}-${text}`} className={styles.item}>
                    <CMSLink
                        href={url}
                        className={clsx(styles.link, 'hover-effect-underline-center')}
                        onClick={onNavigationClick}
                    >
                        {text}
                    </CMSLink>
                </li>
            ))}
        </ul>
    );
};
